import { useMutation, useQueryClient } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";

import { AutomationCollection } from "../types/automation";
import { AUTOMATION_COLLECTIONS_QUERY_KEY } from "./useFetchAutomationCollections";

const postAutomation = async (automation: AutomationCollection) => {
  if (!automation) throw new Error("No automation provided");
  // Adjust the URL as needed for your backend endpoint
  const response = await axios.post(
    `${AUTOMATION_SERVICE_ADDRESS}/automation`,
    automation
  );
  return response.data;
};

export default function usePostAutomation() {
  const queryClient = useQueryClient();
  return useMutation(postAutomation, {
    onSuccess: () => queryClient.invalidateQueries(AUTOMATION_COLLECTIONS_QUERY_KEY)
  });
}
